import React from 'react';
import { Button } from '../../Common/Button';
import { createUseStyles } from 'react-jss';

interface ITutorialDialogProps {
    children: React.ReactNode;
    continueLabel: string;
}
const useStyles = createUseStyles({
    root: {
        lineHeight: 1.4,
    },
});

export const TutorialDialog: React.FunctionComponent<ITutorialDialogProps> = props => {
    const styles = useStyles();
    return (
        <div className={styles.root}>
            {props.children}
            <form method="dialog">
                <Button>{props.continueLabel}</Button>
            </form>
        </div>
    );
};
